import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styles from './_radio.scss'

const Radio = ({
  checked,
  onChange,
  onClick,
  disabled,
  label,
  name,
  ...props
}) => {
  const disabledClass = disabled ? styles.disabled : ''
  const checkedClass = checked ? styles.checked : styles.unchecked

  return (
    <div className={styles.radio}>
      <label
        className={[styles.radioContainer, disabledClass]
          .concat(checkedClass)
          .join(' ')}
      >
        <input
          data-testid='radio'
          name={name}
          disabled={disabled}
          type='radio'
          checked={checked}
          onChange={
            onChange
              ? ({ target }) => onChange(target.checked)
              : /* istanbul ignore next */ null
          }
          {...props}
        />
        <div
          className={[styles.radio, checkedClass, disabledClass].join(' ')}
        />
      </label>
      <p className={[styles.radioLabel].join(' ')}>{label}</p>
    </div>
  )
}

Radio.defaultProps = {
  disabled: false,
  checked: false,
  label: '',
  name: '',
  onChange: /* istanbul ignore next */ () => null
}

Radio.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func
}

export default Radio
